import Event from '../event-class/event'
/*
    events示例：
    {
        loading: () => {},
        playing: () => {},
        end: () => {},
        endAuto: (res) => {},
        error: () => {}
    }
*/
function SDKVoice(record, events) {
    this.serverId = record.serverId
    this.audioId = ""
    this.events = events
    this.playFlag = false

    // 继承自定义事件类(伪继承)
    Event.call(this)

    this.bindEvent()
}

// 订阅事件
SDKVoice.prototype.bindEvent = function () {
    let evts = this.events
    for (let name in evts) {
        typeof evts[name] === "function" && this.on(name, evts[name])
    }
}

// 解绑事件
SDKVoice.prototype.unbindEvent = function () {
    for (let name in evts) {
        this.off(name)
    }
}

SDKVoice.prototype.play = async function () {
    if (!this.audioId) {
        this.audioId = await app.sdk.downloadVoice({
            serverId: this.serverId,
        })
    }

    console.log(this.audioId);
    
    app.sdk.playVoice(this.audioId)
        .then(res => {
            // alert('play');
            this.playFlag = true
            this.emit('playing')
        })

    // 监听语音播放完毕
    app.sdk.onVoicePlayEnd()
        .then(res => {
            // alert('endAuto');
            this.playFlag = false
            this.emit("endAuto", res)
        })
}

SDKVoice.prototype.stop = function () {
    if (this.playFlag) {
        return app.sdk.stopVoice(this.audioId)
            .then(res => {
                this.playFlag = false
                this.emit("end")
                return 'stop'
            })
    } else {
        return Promise.resolve('stop')
    }
}

export default SDKVoice
